// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"ed41f479","216":"f3e9af75","226":"9b65b93a","463":"2d9ade9e","475":"0ede2a86","482":"f7e92048","524":"d6a65430","542":"885a8ae5","576":"ab2577ea","607":"2932e404","628":"2887f735","669":"52eca663","696":"b8f8484f","951":"55180957","983":"09afec61","988":"aeef94ec"}[chunkId] + ".chunk.js";
};